(function () {
    'use strict';

    function requestForProposalBasicInformationController($scope, $timeout, $state, $uibModal, $window,
        milestones, milestoneModalService, notifyService, requestForProposalStateService) {
        var vm = this;
        vm.rfpData = requestForProposalStateService.get();
        vm.rfpId = vm.rfpData.Id.split('/')[1];

        vm.modelOptions = {
            updateOn: 'default blur',
            debounce: {
                "default": 1000,
                "blur": 0
            }
        };

        vm.tinymceOptions = {
            height: "200",
            menubar: false,
            statusbar: false,
            resize: false,
            plugins: [
                "advlist autolink link paste"
            ],
            advlist_bullet_styles: "disc",
            toolbar: "undo redo | bold italic | bullist | link",
            valid_elements: '*[*]',
            debounce: true
        };

        milestoneModalService.getMilestonesAndTemplates(milestones).then(function (milestonesAndTemplates) {
            if (milestonesAndTemplates.length > 0) {
                milestoneModalService.openModal(milestonesAndTemplates);
            }
        });

        vm.updateRfp = function (fieldName) {
            $timeout(function() {
                if (fieldName) {
                    notifyService.notify('You updated the ' + fieldName + 'for this RFP');
                }

                requestForProposalStateService.update(vm.rfpData);
            }, 0);
        }

        var formWatcher = $scope.$watch(function() { return $scope.BasicInformationForm &&
            $scope.BasicInformationForm.$valid },
            function (newVal) {
                vm.canAdvance = newVal;
            });

        vm.openDeleteAlert = function (state) {
            var modalInstance = $uibModal.open({
                templateUrl: 'deleteRequestForProposalModal',
                controller: 'deleteRequestForProposalModalController',
                resolve: {
                    rfpId: function () {
                        return vm.rfpData.Id;
                    }
                }
            });

            return modalInstance.result.then(function (wasDeleted) {
                if (wasDeleted) {
                    $window.location = '/dashboard';
                }
            });
        }

        $scope.$on("$destroy", function () {
            formWatcher();
        });
    }

    requestForProposalBasicInformationController.$inject = ['$scope', '$timeout', '$state', '$uibModal', '$window',
        'milestones', 'milestoneModalService', 'notifyService', 'requestForProposalStateService'];

    angular.module('ecap.requestForProposal').controller('requestForProposalBasicInformationController', requestForProposalBasicInformationController);
})();
